import React, { useMemo } from 'react';

import { LoadingWheel } from '../../base/LoadingWheel';
import { Select } from '../../base/Select';

import useSuperAdminApplianceModels from '../../../data/appliance/useSuperAdminApplianceModels';

export interface ModelSelectProps {
  manufacturer: string;
  type?: string;
  label?: string;
}

export const SuperAdminModelSelect = React.forwardRef<any, ModelSelectProps>(
  ({ manufacturer, type, label, ...rest }, ref) => {
    const { superAdminApplianceModels } = useSuperAdminApplianceModels();

    const filteredModels = useMemo(() => {
      if (!superAdminApplianceModels.data) return [];
      return superAdminApplianceModels.data.filter(
        (model) =>
          model.hardwareManufacturerId === manufacturer &&
          (type ? model.hardwareTypeId === type : true)
      );
    }, [superAdminApplianceModels.data, manufacturer, type]);

    if (superAdminApplianceModels.isLoading) {
      return (
        <div className="flex items-center justify-center">
          <LoadingWheel size="sm" />
        </div>
      );
    } else {
      return (
        <Select
          disabled={!manufacturer}
          ref={ref}
          label={label ? label : 'Model'}
          {...rest}
        >
          <option disabled selected hidden></option>
          {filteredModels?.map((type) => (
            <option key={type.id} value={type.id}>
              {type.name}
            </option>
          ))}
        </Select>
      );
    }
  }
);
